/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/Components/GenericEndpointComponents/GenericAuthPickerComponent" />
import * as React from "react";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { ServiceEndpointType, ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { cloneEndpoint } from "DistributedTaskUI/ServiceEndpoints/Editor/Utils/EndpointsEditorPanelUtils";
import { RadioButton, RadioButtonGroup } from "VSSUI/RadioButton";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";

export interface IGenericAuthPickerComponentProps {
    callbackToSaveState: (endpoint: ServiceEndpoint) => void;
    serviceEndpointType: ServiceEndpointType;
    serviceEndpoint: ServiceEndpoint;
}

export class GenericAuthPickerComponent extends VssComponent<IGenericAuthPickerComponentProps, {}> {
    constructor(props: IGenericAuthPickerComponentProps, context: IVssComponentContext) {
        super(props, context);
        this._draftServiceEndpoint = this.props.serviceEndpoint;
    }

    public UNSAFE_componentWillReceiveProps(props: IGenericAuthPickerComponentProps) {
        this._draftServiceEndpoint = props.serviceEndpoint;
    }

    public render(): React.ReactNode {
        if (this.props.serviceEndpointType && this.props.serviceEndpointType.authenticationSchemes.length > 1) {
            return (
                <div className="auth-scheme-selection-section">
                    <RadioButtonGroup
                        onSelect={(selectedScheme: string) => {
                            this._draftServiceEndpoint.authorization.scheme = selectedScheme;
                            this._draftServiceEndpoint.authorization.parameters = {};
                            this.props.callbackToSaveState(this._draftServiceEndpoint);
                        }}
                        selectedButtonId={this._getSelectedAuthSchemeId()}
                        text={Resources.AuthenticationPickerHeader}
                    >
                        {
                            this.props.serviceEndpointType && this.props.serviceEndpointType.authenticationSchemes.map((authScheme, index) => {
                                return (
                                    <RadioButton id={authScheme.scheme} text={authScheme.displayName} key={index.toString()} />
                                );
                            })
                        }
                    </RadioButtonGroup>
                </div>
            );
        } else {
            return (<div />);
        }
    }

    private _getSelectedAuthSchemeId(): string {
        if (this._draftServiceEndpoint.authorization && this._draftServiceEndpoint.authorization.scheme) {
            return this._draftServiceEndpoint.authorization.scheme;
        }

        return this.props.serviceEndpointType && this.props.serviceEndpointType.authenticationSchemes[0].scheme && "";
    }

    private _draftServiceEndpoint: ServiceEndpoint;
}
